import React from "react";
import { motion } from "framer-motion";

function TechIconCard({ icon, name }) {
  return (
    <motion.div
      className="tech-icon-card"
      whileHover={{
        y: -10,
        scale: 1.08,
        transition: { duration: 0.25, ease: [0.22, 1, 0.36, 1] },
      }}
      whileTap={{ scale: 0.95 }}
    >
      <div className="tech-icon-glow" />
      <div className="tech-icons">{icon}</div>
      <span className="tech-icon-label">{name}</span>
    </motion.div>
  );
}

export default TechIconCard;
